import { render, staticRenderFns } from "./BdTodo.vue?vue&type=template&id=437475a9&"
import script from "./BdTodo.vue?vue&type=script&lang=js&"
export * from "./BdTodo.vue?vue&type=script&lang=js&"
import style0 from "./BdTodo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports